exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-3c22120d]:export {\n  primary: #aa4121;\n  secondary: #ccc;\n  gray: #636363;\n}\n.title div input[data-v-3c22120d] {\n  border-radius: 20px 0 0 20px;\n  border-right: none;\n  padding-left: 20px;\n}\n.title div .input-group-append .input-group-text[data-v-3c22120d] {\n  max-width: 50px;\n  border-radius: 0 20px 20px 0;\n  border-left: none;\n  background: none;\n}\n.title div .input-group-append .input-group-text .fa[data-v-3c22120d] {\n  font-size: 1.1rem;\n}", ""]);

// exports
